import { render } from "./FuntelWelfare.vue?vue&type=template&id=063d32f6&scoped=true"
import script from "./FuntelWelfare.vue?vue&type=script&lang=js"
export * from "./FuntelWelfare.vue?vue&type=script&lang=js"

import "./FuntelWelfare.vue?vue&type=style&index=0&id=063d32f6&lang=scss&scoped=true"

import exportComponent from "/Users/liuli/Desktop/istory/vue3-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063d32f6"]])

export default __exports__